import Swiper from 'swiper/bundle';
import { Tab } from "bootstrap";


export function verticalTabSlider() {

  if (document.querySelector('.verticalTabSwiper')) {


    const tabEls = [...document.querySelectorAll('#verticalTabs button[data-bs-toggle="tab"]')].map((el, index) => new Tab(el));

    console.log(tabEls);

    const swiper = new Swiper('.verticalTabSwiper', {
      direction: 'horizontal',
      autoHeight: true,
      spaceBetween: 100,
      autoHeight: true,
      loop: true,
      effect: 'creative',
      creativeEffect: {
        prev: {
          shadow: true,
          translate: ['-40%', 0, -200],
          opacity: 0,
        },
        next: {
          shadow: true,
          translate: ['40%', 0, -200],
          opacity: 0,
        },
      },
      // autoplay: {
      //   delay: 5000,
      //   disableOnInteraction: false,
      // },
      pagination: {
        el: '.swiper-pagination',
        type: 'progressbar',
      },
      on: {
        slideChange: function () {
          tabEls[this.realIndex].show();
        }
      }
    });

    // Sync tabs with swiper
    tabEls.forEach((tab, index) => {
      tab._element.addEventListener('click', e => {
        e.preventDefault();
        swiper.slideToLoop(index)
      });
    });
  }


}